import React from 'react'

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 font-serif">
      {/* Logo and Header */}
      <div className="mb-8">
        <div className="font-hand text-3xl mb-4">Plum Village</div>
      </div>

      {/* Introduction */}
      <div className="space-y-6 text-gray-700 leading-relaxed">
        <p className="text-lg">
          Plum Village, near Bordeaux in southwest France, is the largest
          international practice center in the Plum Village tradition, and the
          first monastic community founded by Zen Master Thich Nhat Hanh (Thay)
          in the West.
        </p>

        <p>
          Plum Village is where Thay has realised his dream of building a
          Beloved Community: creating a healthy, nourishing environment where
          people can learn the art of living in harmony with one another and
          with the Earth.
        </p>

        <p>
          Plum Village began in 1982 as a small, rustic farmstead, and has today
          grown into Europe's largest Buddhist monastery, with over 200 resident
          monks and nuns, living and practising in four different hamlets spread
          out across the French countryside. It is a continuation of the
          original "Sweet Potato Community" that Thay first founded near Paris
          in the 1970s, soon after he was exiled from Vietnam.
        </p>
      </div>

      {/* First Image */}
      <div className="my-12">
        <img
          src="https://i0.wp.com/plumvillage.org/wp-content/uploads/2019/08/180-Plum-Village-monastery-in-France-birdseye-view-PHOTO-PVCEB.jpg?resize=768%2C580&ssl=1"
          alt="Aerial view of Plum Village in morning mist"
          className="w-full h-auto rounded-lg"
        />
        <p className="text-sm text-gray-500 mt-2">Upper Hamlet, Plum Village</p>
      </div>

      {/* Main Content */}
      <div className="space-y-6 text-gray-700 leading-relaxed">
        <p>
          At Plum Village we weave mindfulness into all our daily activities,
          training ourselves to be mindful throughout the day: while eating,
          walking, working, or enjoying a cup of tea together. We create an
          environment of peace, joy, and a beautiful, nourishing silence
          environment in which to cultivate the mind of awakening.
        </p>

        <p>
          We enjoy periods of silence, sitting meditation, rest, relaxation,
          mindful work and play. All practitioners who come to Plum Village are
          invited to join in the communal activities in true mindfulness,
          whether it is preparing meals, cleaning or washing dishes, as a way of
          learning to cultivate joy and mindfulness whatever we are doing.
        </p>

        <p>
          Every year, Plum Village welcomes thousands of meditation
          practitioners from all around the world who come to experience the art
          of mindful communal living. Over 40 nationalities are often
          represented at our events. Each season has its own unique flavour,
          with different special programs for children and teenagers.
        </p>
      </div>

      {/* Second Image */}
      <div className="my-12">
        <img
          src="https://i0.wp.com/plumvillage.org/wp-content/uploads/2019/08/082-TNH-teaching-in-Plum-Village-PHOTO-PVCEB.jpg?resize=768%2C479&ssl=1"
          alt="Large gathering in meditation hall"
          className="w-full h-auto rounded-lg"
        />
      </div>

      {/* Additional Content */}
      <div className="space-y-6 text-gray-700 leading-relaxed">
        <p>
          In addition to Spring and Autumn retreat seasons, where visitors are
          welcome to stay for a week or more, Plum Village also offers special
          mindfulness retreats for French speakers, families and young people.
          The annual Summer Retreat, which is open to lay people for up to four
          weeks, is a time for families and individuals to come together to
          practice mindfulness and live simply and harmoniously in community for
          twenty consecutive days.
        </p>
      </div>

      {/* Third Image */}
      <div className="my-12">
        <img
          src="https://i0.wp.com/plumvillage.org/wp-content/uploads/2019/08/182-Eating-the-midday-meal-in-Plum-Village-PHOTO-PVCEB.jpg?resize=768%2C488&ssl=1"
          alt="Monks and nuns walking in mindfulness"
          className="w-full h-auto rounded-lg"
        />
      </div>

      {/* Final Content */}
      <div className="space-y-6 text-gray-700 leading-relaxed">
        <p>
          The Hamlets of Plum Village run a volunteer programme for youth
          service, and have opened an organic "Happy Farm," where year-long
          resident farmers combine ecology and mindfulness as they cultivate
          vegetables for the community's vegan meals.
        </p>

        <p>
          Before recently returning to his native Vietnam, Thich Nhat Hanh lived
          at Plum Village when he was not travelling. While in Plum Village he
          wrote, taught, gardened and guided the global community. Many of the
          basic mindfulness practices that are now being applied in schools and
          elsewhere were developed in meditation by Thich Nhat Hanh and his
          community.
        </p>

        <p>
          Today there are a further ten monastic practice centers in the Plum
          Village tradition in Europe, the USA and Asia, all founded by Thich
          Nhat Hanh himself.
        </p>
      </div>

      {/* Legal Information */}
      <div className="mt-12 pt-8 border-t border-gray-200">
        <h2 className="font-semibold text-gray-900 mb-4">Legal Information</h2>
        <div className="text-sm text-gray-600 space-y-2">
          <p>Plum Village is registered as:</p>
          <p>Communauté Bouddhique Zen Village des Pruniers</p>
          <p>Le Pey – Loubès Bernac</p>
          <p>47120 THÉNAC</p>
          <p>SIRET: 425 142 957 00019</p>
        </div>
      </div>
    </div>
  );
}
